import { CallToAction } from '@/graphql/types';
import { filter } from 'lodash';

const MAX_FEATURED_LINKS = 5;

export function useGetFeaturedLinks(ctas?: CallToAction[], featuredLinkIds?: string[]) {
  const allLinks = ctas ?? [];

  const featuredLinks = filter(allLinks, link => featuredLinkIds!.includes(link?.id || '')) || [];
  const maxFeaturedLinksReached = featuredLinkIds?.length === MAX_FEATURED_LINKS;

  return {
    allLinks,
    featuredLinks,
    maxFeaturedLinksReached,
  };
}
